import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'
import tash from 'alpinejs-tash'

// Components
import accordion from './alpine/accordion.js'
import alert from './alpine/alert.js'
import darkmode from './alpine/darkmode.js'
import resourceFilter from './alpine/filter-resources.js'
import newsEventFilter from './alpine/filter-news-events.js'
import nav from './alpine/nav.js'
import video from './alpine/video.js'

// Initialise alpine plugins
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(persist)
Alpine.plugin(tash)

// Initialise alpine components
Alpine.data('accordion', accordion)
Alpine.data('alert', alert)
Alpine.data('darkmode', darkmode)
Alpine.data('resourceFilter', resourceFilter)
Alpine.data('newsEventFilter', newsEventFilter)
Alpine.data('nav', nav)
Alpine.data('video', video)

// Initialise alpine
window.Alpine = Alpine
Alpine.start()

// Open Offsite Links and PDFs in New Tab
let links = [...document.links].forEach((link) => {
    if (link.hostname != window.location.hostname) {
        link.target = '_blank'
    }
})
